var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.localeZH)?_c('div',[(_vm.isPc)?_c('PcHome',{attrs:{"query":_vm.query}}):_c('MobileHome',{attrs:{"query":_vm.query}})],1):_vm._e(),(_vm.localeEN)?_c('div',[(_vm.isPc)?_c('SplatPcHome',{attrs:{"query":_vm.query}}):_c('SplatMobileHome',{attrs:{"query":_vm.query}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }